<template>
  <a :href="content.link" class="address" target="_blank">
    <Icon id="marker" class="address__marker" />
    <p>{{ `${content.address}` }}</p>
    <p>{{ `${content.postal_code} ${content.city}, ${content.state}` }}</p>
  </a>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'AddressLink',
  components: { Icon },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
